import { z } from 'zod';

export const SubscriptionPaymentWebhookSchema = z.object({
  merchantId: z.string(),
  merchantTranId: z.string(),
  bankRRN: z.string(),
  txnStatus: z.enum(['SUCCESS', 'FAILED', 'PENDING']),
  amount: z.string(),
  payerVa: z.string().optional(), // UPI VPA
  payerName: z.string().optional(),
  txnDateTime: z.string(),
  mandateId: z.string().optional(),
  errorCode: z.string().optional(),
  errorMessage: z.string().optional(),
});

export type SubscriptionPaymentWebhookPayload = z.infer<typeof SubscriptionPaymentWebhookSchema>;
